import React, { useEffect, useState } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { getSessionMetrics, SessionMetricsWeek } from '../../services/adminApi';

export const SessionMetrics: React.FC = () => {
  const [data, setData] = useState<SessionMetricsWeek[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getSessionMetrics()
      .then(setData)
      .catch(() => setError('Failed to load session metrics'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-loading">Loading session metrics...</div>;
  if (error) return <div className="admin-error">{error}</div>;
  if (!data.length) return <div className="admin-empty">No session data yet.</div>;

  return (
    <div className="admin-chart-container">
      <h3>Weekly Session Metrics</h3>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" tick={{ fontSize: 11 }} />
          <YAxis yAxisId="left" />
          <YAxis yAxisId="right" orientation="right" />
          <Tooltip />
          <Legend />
          <Bar yAxisId="left" dataKey="avg_duration" fill="#3b82f6" name="Avg Duration (min)" />
          <Bar yAxisId="left" dataKey="avg_questions" fill="#8b5cf6" name="Avg Questions" />
          <Bar yAxisId="right" dataKey="sessions_per_user" fill="#f59e0b" name="Sessions/User" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
